import axios from '@/utils/request'
import base from '@/api/base'
import qs from 'qs'

export function userListAll(data) {
  return axios.get(`${base.url}/auth/private/list?` + qs.stringify(data))
}
export function delUserList(id) {
  return axios.delete(`${base.url}/auth/private/delete?id=${id}`)
}
export function permissionsListAll() {
  return axios.get(`${base.url}/auth/private/permissions`);
}
export function rolesList(id) {
  return axios.get(`${base.url}/auth/private/roles?modelId=${id}`);
}
export function usersList(id) {
  return axios.get(`${base.url}/auth/private/users?roleId=${id}`);
}
export function save(data) {
  return axios.post(`${base.url}/auth/private/save`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
}
export function srcRoles(id) {
  return axios.get(`${base.url}/auth/private/srcRoles`);
}
